export default __webpack_public_path__ + "static/media/link.eec75249.svg";